import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import UploadPicture from '@blade-sxp/portrait-management/pages/components/upload-picture.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { EPortraitStatus, EPassCodeStatus, } from '@blade-sxp/portrait-management/interfaces/portrait';
import { addPortrait, queryPortraitDetail, updatePortrait } from '@blade-sxp/portrait-management/api/portrait';
import { Scale } from '@blade/common/utils/auto-scale';
import { PageQueryTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { portraitCreateI18nKey } from '@blade-sxp/portrait-management/routes';
import ImageUtil from '@blade-sxp/portrait-management/utils/image-util';
import PassCodeDialog from '@blade-sxp/portrait-management/components/pass-code/index.vue';
const Webapi = {
    addPortrait,
    updatePortrait,
    queryPortraitDetail,
};
let default_1 = class default_1 extends Vue {
    formTextareaRows = 5;
    formLabelWidth = 80 * Scale + 'px';
    formInputMaxLength = 50;
    formPhoneInputMaxLength = 20;
    formNoteInputMaxLength = 50;
    defaultValueFormat = 'yyyy-MM-dd';
    passCode = {
        stepKey: 'view',
        visible: false,
        vIf: false,
        disabled: true,
        date: [],
    };
    prefixIcon = 'el-icon-date';
    permanentlt = 'PERMANENTLY';
    custom = 'CUSTOM';
    form = {
        name: '',
        libIds: [],
        gender: 'UNKNOWN',
        country: '',
        birthDay: '',
        phone: '',
        email: '',
        department: '',
        entryTime: '',
        identityId: '',
        identityType: '',
        workId: '',
        externalBizId: '',
        icCard: '',
        remark: '',
        images: [],
        validateType: this.permanentlt,
        validateEndDate: [],
    };
    rules = {
        name: [{ required: true, message: this.$t('nameInputPlaceholder'), trigger: ['blur', 'change'] }],
        // images: [{ type: 'array', required: true, message: this.$t('imageInputPlaceholder'), trigger: 'change' }],
        // email: [
        //   { required: false, trigger: 'blur' },
        //   { type: 'email', message: this.$t('emailRulePlaceholder'), trigger: 'blur' },
        // ],
        validateEndDate: [{ required: true, validator: this.checkEffectiveDate, trigger: ['blur', 'change'] }],
    };
    portraitStatus = 'INVALIDATING'; // 失效
    submiting = false;
    loading = false;
    isDetail = false;
    pleaseSelectExpirationDate = this.$t('pleaseSelectExpirationDate');
    // 允许提交
    allowSubmit = false;
    get startDateTips() {
        return this.form.validateType === 'PERMANENTLY' ? '' : this.$t('startDateTips');
    }
    get endDateTips() {
        return this.form.validateType === 'PERMANENTLY' ? '' : this.$t('endDateTips');
    }
    get rangeSeparator() {
        return this.form.validateType === 'PERMANENTLY' ? '' : '-';
    }
    onForm(nv) {
        console.log('onForm nv', JSON.stringify(nv));
        this.updateAllowSubmit();
    }
    handlePassCode() {
        this.passCode.visible = true;
    }
    updateAllowSubmit() {
        this.validateForm((valid) => {
            this.allowSubmit = valid;
        });
    }
    changeValidateType(nv) {
        console.log('changeValidateType', nv);
        if (nv === this.permanentlt)
            this.form.validateEndDate = [];
    }
    checkEffectiveDate(rule, value, callback) {
        const { validateEndDate, validateType } = this.form;
        let is = validateType === 'CUSTOM' ? validateEndDate && validateEndDate.length === 2 : true;
        if (is) {
            callback?.();
        }
        else {
            callback?.(new Error(`${this.$t('effectiveDateTips')}`));
        }
    }
    mounted() {
        this.loading = true;
        this.$router.onReady(async () => {
            const query = this.$route.query;
            if (query.type !== PageQueryTypeEnum.CREATE) {
                await this.queryPortraitDetail(+query.id);
                this.updateAllowSubmit();
            }
            if (query.type === PageQueryTypeEnum.DETAIL) {
                this.isDetail = true;
                // this.rules = {
                //   name: [],
                //   // images: [],
                //   email: [],
                // };
            }
            this.loading = false;
        });
    }
    async queryPortraitDetail(id) {
        try {
            let result = await Webapi.queryPortraitDetail(id);
            if (result) {
                let imagesBase64 = [];
                for (let i = 0; i < result.images.length; i++) {
                    const im = result.images[i];
                    imagesBase64.push((await ImageUtil.urlToBase64(im.path)));
                }
                result.images = imagesBase64;
            }
            if (result) {
                this.form = {
                    ...result,
                    validateEndDate: result.validateType === 'PERMANENTLY' ? [] : [result?.validateStartDate ?? '', result?.validateEndDate ?? ''],
                    validateStartDate: '',
                };
                this.updatePassCodeStepKey(result);
            }
        }
        catch (error) {
            console.log('Webapi.queryPortraitDetail error', error);
        }
    }
    updatePassCodeStepKey(result) {
        this.passCode.vIf = false;
        const portraitStatus = this.form?.portraitStatus ?? '';
        console.log('updatePassCodeStepKey portraitStatus', portraitStatus);
        if (!portraitStatus || portraitStatus === EPortraitStatus.INVALIDATING) {
            // 无效日期，点击通行码无反应
            this.passCode.disabled = true;
            this.passCode.visible = false;
            return;
        }
        const qrCodeState = this.form?.qrCodeState ?? '';
        let stepKey = 'add';
        switch (qrCodeState) {
            case EPassCodeStatus.GENERATED:
                stepKey = 'view';
                break;
            case EPassCodeStatus.UNGENERATE:
                stepKey = 'add';
                break;
        }
        this.passCode.disabled = false;
        this.passCode.vIf = true;
        this.passCode.stepKey = stepKey;
        this.passCode.date = [result?.validateStartDate, result.validateEndDate];
    }
    // 输入手机号
    formatPhone(field) {
        this.form[field] = this.form[field].toString().replace(/[^\d-]/g, '');
    }
    // 输入身份证
    formatIDCard(field) {
        this.form[field] = this.form[field].toString().replace(/[^a-zA-Z0-9]/g, '');
    }
    // 输入邮箱
    formatEmail(field) {
        // (this.form[field as keyof PortraitAddRequest] as string) = this.form[field as keyof PortraitAddRequest]
        //   .toString()
        //   .replace(/[^a-zA-Z0-9]/g, '');
        // TODO 确认校验输入字符
        console.log(field);
    }
    // 输入默认
    formatDefault(field) {
        this.form[field] = this.form[field].toString().replace(/[^\u4e00-\u9fa5_a-zA-Z0-9_]/g, '');
    }
    handleCancel() {
        this.$router.back();
    }
    handleEdit(item) {
        const query = this.$route.query;
        this.$router.replace({ name: 'portraitCreate', query: { ...query, type: PageQueryTypeEnum.EDIT, id: item.portraitId.toString() } });
        this.isDetail = false;
        if (this.$route.meta && this.$route.meta.breadcrumbs) {
            let breadcrumbs = this.$route.meta.breadcrumbs;
            let lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1];
            if (lastBreadcrumb.meta)
                lastBreadcrumb.meta.title = portraitCreateI18nKey[PageQueryTypeEnum.EDIT];
        }
        this.updateAllowSubmit();
    }
    validateForm(call) {
        return new Promise((resolve, reject) => {
            this.$refs['form']?.validate?.((valid) => {
                console.log('validateForm valid', valid);
                call && call(valid);
                resolve(valid);
            });
        });
    }
    handleSubmit() {
        if (this.form.validateType === this.custom && !this.form.validateEndDate)
            return this.$elmessage.warning(this.$t('pleaseSelectExpirationDate').toString());
        const query = this.$route.query;
        this.validateForm((valid) => {
            if (valid) {
                const { validateEndDate } = this.form;
                if (query.type === PageQueryTypeEnum.CREATE) {
                    let form = {
                        ...this.form,
                        validateStartDate: validateEndDate?.[0],
                        validateEndDate: validateEndDate?.[1],
                        libIds: [+query.libId],
                    };
                    this.addPortrait(form);
                }
                else if (query.type === PageQueryTypeEnum.EDIT) {
                    let form = {
                        ...this.form,
                        validateStartDate: validateEndDate?.[0],
                        validateEndDate: validateEndDate?.[1],
                        libIds: [+query.libId],
                        portraitId: +query.id,
                    };
                    this.updatePortrait(form);
                }
            }
            else {
                console.log('validate error !');
                return false;
            }
        });
    }
    async addPortrait(form) {
        if (this.submiting)
            return;
        this.submiting = true;
        try {
            await Webapi.addPortrait(form);
            this.$message({
                customClass: 'success-message',
                message: this.$t('createSuccessfully').toString(),
                type: 'success',
                showClose: true,
            });
            this.$router.back();
        }
        catch (error) { }
        this.submiting = false;
    }
    async updatePortrait(form) {
        if (this.submiting)
            return;
        this.submiting = true;
        try {
            await Webapi.updatePortrait(form);
            this.$message({
                customClass: 'success-message',
                message: this.$t('editSuccessfully').toString(),
                type: 'success',
                showClose: true,
            });
            this.$router.back();
        }
        catch (error) { }
        this.submiting = false;
    }
};
__decorate([
    Watch('form', { deep: true })
], default_1.prototype, "onForm", null);
default_1 = __decorate([
    Component({
        components: {
            UploadPicture,
            PassCodeDialog,
        },
        i18n: {
            messages: {
                en: {
                    ...lang.en,
                    nameInputPlaceholder: 'Please enter name',
                    nationalityInputPlaceholder: 'Please enter nationality',
                    birthdateInputPlaceholder: 'Please select date of birth',
                    telephoneInputPlaceholder: 'Please enter telephone',
                    emailInputPlaceholder: 'Please enter email',
                    departmentInputPlaceholder: 'Please enter the department, such as xxx/xxx',
                    entryTimeInputPlaceholder: 'Please select the time of joining',
                    identityNumberInputPlaceholder: 'Please enter the ID',
                    employeeIDInputPlaceholder: 'Please enter employee ID',
                    passIDInputPlaceholder: 'Please enter pass ID',
                    icCardNumberInputPlaceholder: 'Please enter IC card number',
                    noteInputPlaceholder: 'Please enter note',
                    imageInputPlaceholder: 'Upload at least one picture',
                    emailRulePlaceholder: 'Please enter the correct email address',
                    effectiveDateTips: 'Please select date',
                    startDateTips: 'Start',
                    endDateTips: 'End',
                },
                zh: {
                    ...lang.zh,
                    nameInputPlaceholder: '请输入名称',
                    nationalityInputPlaceholder: '请输入国籍',
                    birthdateInputPlaceholder: '请选择出生日期',
                    telephoneInputPlaceholder: '请输入电话',
                    emailInputPlaceholder: '请输入电子邮箱',
                    departmentInputPlaceholder: '请输入部门，例如xxx/xxx',
                    entryTimeInputPlaceholder: '请选择入职时间',
                    identityNumberInputPlaceholder: '请输入身份号码',
                    employeeIDInputPlaceholder: '请输入员工ID',
                    passIDInputPlaceholder: '请输入通行证ID',
                    icCardNumberInputPlaceholder: '请输入IC卡号码',
                    noteInputPlaceholder: '请输入备注',
                    imageInputPlaceholder: '至少上传一张图片',
                    emailRulePlaceholder: '请输入正确的邮箱地址',
                    effectiveDateTips: '请选择日期',
                    startDateTips: 'Start',
                    endDateTips: 'End',
                },
            },
        },
    })
], default_1);
export default default_1;
